export default {
      id: "mini-mic-usage",
      viewBox: "0 0 36 36",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#mini-mic",
      toString: function () {
        return this.url;
      }
    }